import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '../../../common/components/SectionWrapper/SectionWrapper'
import {
  DetailInfo,
  DetailRow,
} from '../../../common/components/DetailRow/DetailRow'
import { useStyles } from './Sections.styles'
import { dateAndTimeConversion } from '../../../common/utils/dateAndTimeConversion'
import { useSelector } from '../../../store'
import { ColumnReadMore } from '@labrav/common'
import { ViewValueWithTruncate } from '@labrav/common'
import { MsftCombinedFormState } from '../../../modules/microsoftCombinedForm/reducer'

export const OfferDetails = ({
  microsoftCombinedFormDetails,
}: {
  microsoftCombinedFormDetails?: MsftCombinedFormState
}) => {
  const { classes } = useStyles()

  const timeZone = useSelector<string>(
    state =>
      state.userProfile.userProfile.timeZone ||
      state.userProfile.userProfile.defaultTimeZone ||
      'UTC'
  )

  return (
    <div>
      <SectionWrapper heading="Offer details" icon={faListUl} varient="small">
        <div className={classes.sectionContent}>
          <DetailRow borderBottom>
            <>
              <DetailInfo
                title="Buyer name"
                value={
                  <ViewValueWithTruncate
                    value={
                      microsoftCombinedFormDetails?.draftOffer?.companyName
                    }
                  />
                }
                keyName="cloudOfferId"
              />
              <DetailInfo
                title="Buyer billing account ID"
                value={
                  <ViewValueWithTruncate
                    value={
                      microsoftCombinedFormDetails?.draftOffer?.beneficiaryId
                    }
                    showIcon={true}
                  />
                }
                keyName="labraOfferId"
              />
            </>
          </DetailRow>
          <DetailRow borderBottom>
            <>
              <DetailInfo
                title="Offer name"
                value={
                  <ViewValueWithTruncate
                    value={microsoftCombinedFormDetails?.draftOffer?.mppoName}
                  />
                }
                keyName="mppoName"
              />
              <DetailInfo
                title="Offer expiration date"
                value={
                  microsoftCombinedFormDetails?.draftOffer?.acceptBy
                    ? (() => {
                        const { modifiedDate, modifiedTime } =
                          dateAndTimeConversion(
                            microsoftCombinedFormDetails?.draftOffer?.acceptBy,
                            timeZone
                          )
                        return (
                          <div className={classes.dateTimeWrapper}>
                            <div className={classes.createdAtDate}>
                              {modifiedDate}
                            </div>
                            {modifiedTime && (
                              <div className={classes.createdAtTime}>
                                {modifiedTime.trim()}
                              </div>
                            )}
                          </div>
                        )
                      })()
                    : '-'
                }
                keyName="acceptBy"
              />
            </>
          </DetailRow>
          <DetailRow borderBottom>
            <>
              <DetailInfo
                title="ISV"
                value={<ViewValueWithTruncate value={'need to think'} />}
                keyName="mppoName"
              />
              <DetailInfo
                title="Product"
                value={
                  <ViewValueWithTruncate
                    value={microsoftCombinedFormDetails?.draftOffer.mppoName}
                  />
                }
                keyName="product"
              />
            </>
          </DetailRow>
          <DetailRow borderBottom>
            <>
              <DetailInfo
                title="Offer description"
                value={
                  microsoftCombinedFormDetails?.draftOffer?.mppoDescription ? (
                    <ColumnReadMore
                      customCharForRemoveFromMax={15}
                      initializeWithLowerCase
                      description={
                        microsoftCombinedFormDetails?.draftOffer
                          ?.mppoDescription
                      }
                    />
                  ) : (
                    '-'
                  )
                }
                keyName="mppoDescription"
              />
              <DetailInfo
                title="Offer ID"
                value={
                  microsoftCombinedFormDetails?.azureMppoId ? (
                    <ViewValueWithTruncate
                      value={microsoftCombinedFormDetails?.azureMppoId}
                      showIcon={true}
                    />
                  ) : (
                    '-'
                  )
                }
                keyName="azureMppoId"
              />
            </>
          </DetailRow>
          <DetailRow borderBottom>
            <>
              <DetailInfo
                title="Selected currency"
                value={'USD'}
                keyName="currency"
              />
              <DetailInfo
                title="Renewal"
                value={
                  microsoftCombinedFormDetails?.draftOffer
                    ?.existingContractRenewal
                    ? 'Yes'
                    : 'No'
                }
                keyName="existingContractRenewal"
              />
            </>
          </DetailRow>
        </div>
      </SectionWrapper>
    </div>
  )
}
